// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"O2-z","dimensionLabel":"P2-z","styleChooserControlWrapper":"Q2-z","styleChooserControl":"R2-z","disabled":"S2-z","giftCard":"T2-z","styleChooserText":"U2-z"};